import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { SearchDataResponse } from "../../../business";
import { SearchPageFactory } from "../../interfaces";
import { SearchContent } from "../screens";

export class SearchPageFactoryImpl implements SearchPageFactory {
    create(searchData: SearchDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (searchData?.success && searchData.success === true) {
            return <SearchContent data={searchData.response} />
        }
        return <NoDataComponent />
    }
}